import $ from 'jquery';
import Cookie from 'js-cookie';
import Backbone from 'source/lib/backbone';
import ajaxrequest from 'wg-ajaxrequest';
import Settings from './settings_model';
import addCustomHeaders from './utils/add_custom_http_headers';

window.Settings = window.Settings || {};

// Custom headers
const CUSTOM_HEADERS = [
    {
        name: 'X-U-Sgn',
        value: () => window.WGNI_Signature,
        condition: (settings) => {
            // Добавляем заголовок только для POST запросов на URL авторизации
            const loginCreateUrl = Settings.get('Authentication.LoginCreateUrl');
            return settings.type === 'POST'
                && settings.url
                && settings.url.indexOf(loginCreateUrl) !== -1;
        },
    },
];

const originalBeforeSend = $.ajaxSettings.beforeSend;

$.ajaxSetup({
    traditional: true,
    beforeSend(xhr, settings) {
        if (originalBeforeSend) {
            originalBeforeSend.call(this, xhr, settings);
        }

        addCustomHeaders(xhr, settings, CUSTOM_HEADERS);
    },
});

function enableCsrfToken(appid) {
    const cookieName = Settings.get('App.CsrfCookieName')
        || `${appid || Settings.appName || ''}_csrftoken`;
    const cookiePath = Settings.get('App.CsrfCookiePath') || '/id/';
    const CSRF_TOKEN = Cookie.get(cookieName) || window.Settings.CSRF_TOKEN;

    if (CSRF_TOKEN) {
        // Sync token by all place
        Cookie.set(cookieName, CSRF_TOKEN, { path: cookiePath });
        window.Settings.CSRF_TOKEN = CSRF_TOKEN;
    }

    return CSRF_TOKEN;
}

function ajax(params) {
    const CSRF_TOKEN = Backbone.enableCsrfToken();

    if (params.type === 'POST' && !CSRF_TOKEN) {
        Settings.syncAccountState(true);
    }

    return ajaxrequest.submit(params.data, params);
}

Backbone.enableCsrfToken = enableCsrfToken;
Backbone.ajax = ajax;

export {
    ajax,
    enableCsrfToken,
};
